import { HelperService } from 'src/app/service/helper.service';
import { Injectable } from '@angular/core';
import { Observable, distinctUntilChanged, flatMap, map, mergeMap, of, switchMap } from 'rxjs';
import { LookupFeatures } from '../model/feature-mapping';
import { Feature } from '../model/rootObjectFeature';
import { FeatureEntityService } from './feature-entity.service';

import { RegionEntityService } from '../../common-components/service/region-entity.service';
import { CountyEntityService } from '../../common-components/service/county-entity.service';
import { County } from 'src/app/model/county';
import { DistrictEntityService } from '../../common-components/service/district-entity.service';
import { SchoolEntityService } from '../../common-components/service/school-entity.service';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { Region } from '../../../model/region.model';
import { GeographicalRegions } from '../../party/model/geographicalRegions.model';
import { GeographicalEntityService } from '../../common-components/service/geographical-entity.service';
import { ContactMechanismEntityService } from '../../common-components/service/contact-mechanism-entity.service';
import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';
import { ContactMechanismPurposeEntityService } from '../../common-components/service/contact-mechanism-purpose-entity.service';
import { PartyRoleTypes } from '../../party/model/party-role-types.model';
import { PartyRoleTypeEntityService } from '../../common-components/service/party-role-type-entity.service';
import { RoleEntityService } from '../../common-components/service/role-entity.service';
import { Role } from 'src/app/model/roles';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { HttpClient } from '@angular/common/http';
import { CoursetypeEntityService } from '../../common-components/service/coursetype-entity.service';
import { CoursesectionEntityService } from '../../common-components/service/coursesection-entity.service';
import { TermtypeEntityService } from '../../common-components/service/termtype-entity.service';
import { CourseType } from 'src/app/model/course-type';
import { CourseSection } from 'src/app/model/course-section';
import { TermType } from 'src/app/model/term-type';
import { CommunicationEventPurposeTypeEntityService } from '../../common-components/service/communication-event-purpose-type-entity.service';
import { CommunicationEventPurposeType } from '../../children/model/student-communication-events';
import { USERROLESEntity, User } from '../../auth/model/user.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { RegionService } from '../../common-components/region/service/region.service';

@Injectable({
    providedIn: 'root'
})
export class AccessService {
    userLstfeatures: Feature[];
    public lookupFeatures: LookupFeatures = new LookupFeatures();
    //public userLstfeatures$: Observable<any>;

    constructor(
        private featureEntityService: FeatureEntityService,
        private regionEntityService: RegionEntityService,
        private regionService: RegionService,
        private countyService: CountyEntityService,
        private districtService: DistrictEntityService,
        private loginTokenService: LoginTokenService,
        private geographicalEntityService: GeographicalEntityService,
        private contactMechanismEntityService: ContactMechanismEntityService,
        private contactMechanismPurposeEntityService: ContactMechanismPurposeEntityService,
        private partyRoleTypeEntityService: PartyRoleTypeEntityService,
        private roleEntityService: RoleEntityService,
        private courseTypeEntitiyService: CoursetypeEntityService,
        private coursesectionEntityService: CoursesectionEntityService,
        private termtypeEntityService: TermtypeEntityService,
        private communicationEventPurposeTypeEntityService: CommunicationEventPurposeTypeEntityService,
        private urlProvider: UrlProviderService,
        private helperService: HelperService,
        private http: HttpClient
    ) {
        loginTokenService
            .isLoggedIn()
            .pipe(distinctUntilChanged())
            .subscribe((loggedIn) => {
                this.regionEntityService.getAll().subscribe((regions) => {
                    if (loggedIn) {
                        const userToken = localStorage.getItem('userToken');
                        if (userToken) {
                            let objUser = JSON.parse(userToken);
                            this.regionService.searchGetRegionsByPartyId(objUser.user?.PERSON?.PARTy?.ID);
                        }
                        this.countyService.getAll().subscribe((counties: County[]) => {});
                        this.districtService.getAll().subscribe((districts) => {});
                        this.featureEntityService.getAll().subscribe((userLstfeatures) => {
                            //this.userLstfeatures$ = this.featureEntityService.getAll().pipe();
                            this.userLstfeatures = userLstfeatures;
                        });
                        this.geographicalEntityService.getAll().subscribe((x) => {});
                        this.contactMechanismEntityService.getAll().subscribe((x) => {});
                        this.contactMechanismPurposeEntityService.getAll().subscribe((x) => {});
                        this.partyRoleTypeEntityService.getAll().subscribe((x) => {});
                        this.roleEntityService.getAll().subscribe((x) => {});
                    } else {
                        this.userLstfeatures = [];
                    }
                });

                // if (loggedIn) {
                //     console.warn(loggedIn, 'GETTING ALL BECAUSE LOGGED IN');
                //     this.regionService.loaded$.subscribe((regionLoaded) => {
                //         console.warn(regionLoaded);
                //         if (!regionLoaded && loggedIn) {
                //             this.regionService.getAll().subscribe((regions) => {});
                //         }
                //     });

                //     this.regionService.loaded$.subscribe((regionLoaded) => {
                //         console.warn(regionLoaded);
                //         if (regionLoaded && loggedIn) {
                //             //load the county
                //             this.countyService.loaded$.subscribe((countyLoaded) => {
                //                 if (!countyLoaded) {
                //                     this.countyService.getAll().subscribe((counties: County[]) => {});
                //                 }
                //             });

                //             //load the school districts
                //             this.districtService.loaded$.subscribe((districtLoaded) => {
                //                 if (!districtLoaded) {
                //                     this.districtService.getAll().subscribe((districts) => {});
                //                 }
                //             });

                //             //load the schools

                //             // this.helperService.loadingSchools$.subscribe((loading: boolean) => {
                //             //     this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
                //             //         console.warn(loading);
                //             //         if (!loading && userRegion.length > 0) {
                //             //             this.helperService.setLoadingSchools(true);

                //             //             let params: any = { regions: [userRegion[0].ID!.toString()] };
                //             //             params['counties'] = ['8'];
                //             //             this.schoolService.getWithQuery(params).subscribe(() => {});
                //             //             //this.helperService.setLoadingSchools(false);

                //             //             // this.helperService.lstRegion$.subscribe({
                //             //             //     next: (allRegions: Region[]) => {
                //             //             //         allRegions = allRegions.filter((region: Region) => region.ID !== userRegion[0]);
                //             //             //         allRegions = allRegions.filter((region: Region) => region.ID === 19);

                //             //             //         allRegions.forEach((r: Region) => {
                //             //             //             this.schoolService.getWithQuery(r.ID!.toString()).subscribe(() => {});
                //             //             //         });
                //             //             //     },
                //             //             //     error: (err) => {},
                //             //             //     complete: () => {}
                //             //             // });
                //             //         }
                //             //     });
                //             // });
                //         }
                //     });

                //     this.featureEntityService.loaded$.subscribe((featureLoaded) => {
                //         console.warn(featureLoaded);
                //         if (!featureLoaded && loggedIn) {
                //             this.userLstfeatures$ = this.featureEntityService.getAll().pipe();
                //             this.userLstfeatures$.subscribe((x) => {
                //                 this.userLstfeatures = x;
                //             });
                //         }
                //     });

                //     this.geographicalEntityService.loaded$.subscribe((geographicLoaded) => {
                //         if (!geographicLoaded && loggedIn) {
                //             this.geographicalEntityService.getAll().subscribe((x) => {});
                //         }
                //     });

                //     this.contactMechanismEntityService.loaded$.subscribe((contactMechanismLoaded) => {
                //         if (!contactMechanismLoaded && loggedIn) {
                //             this.contactMechanismEntityService.getAll().subscribe((x) => {});
                //         }
                //     });

                //     this.contactMechanismPurposeEntityService.loaded$.subscribe((contactMechanismPurposeLoaded) => {
                //         if (!contactMechanismPurposeLoaded && loggedIn) {
                //             this.contactMechanismPurposeEntityService.getAll().subscribe((x) => {});
                //         }
                //     });

                //     this.partyRoleTypeEntityService.loaded$.subscribe((partyRoleTypeLoaded) => {
                //         if (!partyRoleTypeLoaded && loggedIn) {
                //             this.partyRoleTypeEntityService.getAll().subscribe((x) => {});
                //         }
                //     });
                //     this.roleEntityService.loaded$.subscribe((roleLoaded) => {
                //         if (!roleLoaded && loggedIn) {
                //             this.roleEntityService.getAll().subscribe((x) => {});
                //         }
                //     });
                // } else {
                //     // load region for account request
                //     this.regionService.loaded$.subscribe((regionLoaded) => {
                //         if (!regionLoaded && !loggedIn) {
                //             this.regionService.getAll().subscribe((regions) => {});
                //         }
                //     });
                // }
            });
    }

    allRegion(): Observable<Region[]> {
        return this.regionEntityService.entities$.pipe(
            switchMap((res: Region[]) => {
                return of(res);
            })
        );
    }

    public getGeographical(): Observable<GeographicalRegions[]> {
        return this.geographicalEntityService.entities$.pipe(
            switchMap((res: GeographicalRegions[]) => {
                return of(res);
            })
        );
    }

    public getContactMechanism(): Observable<ContactMechanismTypes[]> {
        return this.contactMechanismEntityService.entities$.pipe(
            switchMap((res: ContactMechanismTypes[]) => {
                return of(res);
            })
        );
    }

    public getContactMechanismPurpose(): Observable<ContactMechanismPurposeTypes[]> {
        return this.contactMechanismPurposeEntityService.entities$.pipe(
            switchMap((res: ContactMechanismPurposeTypes[]) => {
                return of(res);
            })
        );
    }

    public getPartyRoleTypes(): Observable<PartyRoleTypes[]> {
        return this.partyRoleTypeEntityService.entities$.pipe(
            switchMap((res: PartyRoleTypes[]) => {
                return of(res);
            })
        );
    }

    public getRoles(): Observable<Role[]> {
        return this.roleEntityService.entities$.pipe(
            switchMap((res: Role[]) => {
                res.sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                });
                return of(res);
            })
        );
    }

    public loadCourseSection() {
        this.coursesectionEntityService.loaded$.subscribe((courseSections) => {
            if (!courseSections) {
                this.coursesectionEntityService.getAll().subscribe((courseSections) => {});
            }
        });
    }

    public loadCourseType() {
        this.courseTypeEntitiyService.loaded$.subscribe((courseTypes) => {
            if (!courseTypes) {
                this.courseTypeEntitiyService.getAll().subscribe((courseType) => {});
            }
        });
    }
    public loadTermType() {
        this.termtypeEntityService.loaded$.subscribe((termTypes) => {
            if (!termTypes) {
                this.termtypeEntityService.getAll().subscribe((termTypes) => {});
            }
        });
    }

    public getCourseSection(): Observable<CourseSection[]> {
        return this.coursesectionEntityService.entities$.pipe(
            switchMap((res: CourseSection[]) => {
                return of(res);
            })
        );
    }
    public getCourseType(): Observable<CourseType[]> {
        return this.courseTypeEntitiyService.entities$.pipe(
            switchMap((res: CourseType[]) => {
                return of(res);
            })
        );
    }

    public getTermType(): Observable<TermType[]> {
        return this.termtypeEntityService.entities$.pipe(
            switchMap((res: TermType[]) => {
                return of(res);
            })
        );
    }

    public loadCommunicationEventPurposeType() {
        this.communicationEventPurposeTypeEntityService.loaded$.subscribe((cept) => {
            if (!cept) {
                this.communicationEventPurposeTypeEntityService.getAll().subscribe((cept) => {});
            }
        });
    }

    public getCommunicationEventPurposeType(): Observable<CommunicationEventPurposeType[]> {
        return this.communicationEventPurposeTypeEntityService.entities$.pipe(
            switchMap((res: CommunicationEventPurposeType[]) => {
                return of(res);
            })
        );
    }

    /*    loadFeatureData() {
        this.featureEntityService.loaded$.subscribe((loaded) => {
            if (loaded) {
                this.featureEntityService.entities$.subscribe((lstFeature) => {
                    this.lstfeatures = lstFeature;
                });
            }
        });
    }
	*/
    hasRouteaccess(routeName: string): Observable<boolean> {
        //Whether full access or partial access so this place holder will help to identify in the future requirements
        return this.hasAccess(routeName);
    }

    hasAccess(routeName: string): Observable<boolean> {
        let featureMapping = this.lookupFeatures.featureMapping.find((x) => routeName.toLowerCase() === x.routeName.toLowerCase());

        if (featureMapping != undefined && featureMapping?.id > 0) {
            if (featureMapping.enableFeature) {
                let foundFeature = this.userLstfeatures.find((x) => {
                    return x.NAME.toLowerCase() == featureMapping?.name.toLocaleLowerCase();
                });

                return of(foundFeature !== undefined && foundFeature.ID >= 1);
            }
        }

        return of(false);
    }
    hasMenuAccess(menuName: string): Observable<boolean> {
        let lstMenuName: string[] = [];
        if (menuName == 'System') {
            lstMenuName.push('accounts');
            lstMenuName.push('workflows');
            lstMenuName.push('organizations');
            lstMenuName.push('systemschools');
            lstMenuName.push('school districts');
            lstMenuName.push('counties');
            lstMenuName.push('persons');
            lstMenuName.push('system');
        } else {
            lstMenuName.push(menuName.toLowerCase());
        }

        //let featureMapping = this.lookupFeatures.featureMapping.filter((x) => x.menu.toLowerCase() == menuName.toLowerCase());
        let featureMapping = this.lookupFeatures.featureMapping.filter((x) => lstMenuName.includes(x.menu.toLowerCase()));
        let retVal: boolean = false;
        if (featureMapping.filter((x) => x.enableFeature == false).length > 0) {
            return of(true);
        } else {
            this.featureEntityService.loaded$.subscribe((loaded) => {
                if (loaded) {
                    this.userLstfeatures?.forEach((element) => {
                        if (featureMapping.findIndex((x) => x.name.toLowerCase() == element.NAME.toLowerCase()) >= 0) {
                            retVal = true;
                        }
                    });
                }
            });
            return of(retVal);
        }
    }

    getFeatureAccess(features: string[]): Observable<any> {
        let output: any = {};

        features.forEach((feature) => {
            output[feature] = this.userLstfeatures.find((x: any) => {
                return x.NAME.toLowerCase() == feature.toLocaleLowerCase();
            })
                ? true
                : false;
        });

        return of(output);
    }

    getFeatureAccessPromise(features: string[]): Promise<any> {
        let output: any = {};
        let result = new Promise((resolve, reject) => {
            this.featureEntityService.loaded$.subscribe((featureLoaded) => {
                if (featureLoaded) {
                    setTimeout(() => {
                        features.forEach((feature) => {
                            output[feature] = this.userLstfeatures.find((x: any) => {
                                return x.NAME.toLowerCase() == feature.toLocaleLowerCase();
                            })
                                ? true
                                : false;
                        });

                        resolve(output);
                    });
                }
            });
        });

        return result;
    }

    featureAccessible(feature: string): Observable<boolean> {
        let foundFeature = this.userLstfeatures.find((x) => {
            return x.NAME.toLowerCase() == feature.toLowerCase();
        });

        return of(foundFeature !== undefined && foundFeature.ID >= 1);
    }

    nonRegionalUser(): Observable<boolean> {
        let userRoles: string[] = ['System Administrator', 'State Administrator', 'State User Approver'];
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        userRoles.forEach((nRU) => {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == nRU.toLowerCase()) >= 0) {
                retVal = true;
            }
        });
        return of(retVal);
    }
    generalUser(): Observable<boolean> {
        let userRoles: string[] = [
            'I&R Coordinator Manager',
            'Program Coordinator Manager',
            'Office Support',
            'Student Services',
            'General User',
            'INA/ILP Support'
        ];
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        userRoles.forEach((nRU) => {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == nRU.toLowerCase()) >= 0) {
                retVal = true;
            }
        });
        return of(retVal);
    }
    accountApproverUser(): Observable<boolean> {
        let userRoles: string[] = ['State User Approver', 'Regional User Approver'];
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        userRoles.forEach((nRU) => {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == nRU.toLowerCase()) >= 0) {
                retVal = true;
            }
        });
        return of(retVal);
    }
    adminUser(): Observable<boolean> {
        let userRoles: string[] = ['System Administrator', 'State Administrator', 'Regional Administrator'];
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        userRoles.forEach((nRU) => {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == nRU.toLowerCase()) >= 0) {
                retVal = true;
            }
        });
        return of(retVal);
    }
    systemAdministratorUser(): Observable<boolean> {
        let userRoles: string[] = ['System Administrator'];
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        userRoles.forEach((nRU) => {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == nRU.toLowerCase()) >= 0) {
                retVal = true;
            }
        });
        return of(retVal);
    }    
    verifyUserRole(userRole: string): boolean {
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;

        if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == userRole.toLowerCase()) >= 0) return true;
        else return false;
    }
    getSchoolDistrictAccess(): Observable<any> {
        let output: any = {};

        const url = this.urlProvider.getUrl(EndPoints.indexSchoolDistricts, undefined, undefined);
        let userRegion: Region[] = [];

        return this.helperService.lstUserProfileRegion$
            .pipe(
                map((ur: Region[]) => {
                    userRegion = ur;
                }),

                mergeMap((success) => {
                    return this.http.post(url, { regions: userRegion }, (Headers = { ...this.urlProvider.baseGetOptions() }));
                })
            )
            .pipe(
                map((res: any) => {
                    if (res.body['schoolDistricts']) {
                        let schoolDistricts: SchoolDistrict[] = JSON.parse(res.body['schoolDistricts']);

                        schoolDistricts.forEach((sd) => {
                            output[sd.ID] = true;
                        });

                        return output;
                    } else {
                        return undefined;
                    }
                })
            );
    }
    hasRole(role: string): Observable<boolean> {
        let userRoleEntity: USERROLESEntity[] = this.loginTokenService.getUser().USER_ROLES!;
        let retVal: boolean = false;

        if (userRoleEntity) {
            if (userRoleEntity.findIndex((x) => x.ROLE?.NAME?.toLowerCase() == role.toLowerCase()) >= 0) {
                retVal = true;
            }
            return of(retVal);
        } else {
            return of(false);
        }
    }
}
